import { PLATFORM } from "../../config/platform";
import type { ReactNode } from "react";

interface ContentPageProps {
  title: string;
  onBack: () => void;
  children: ReactNode;
}

// Public, static content page (About / Privacy / Contact) with the landing
// header and a back-to-home affordance.
export const ContentPage = ({ title, onBack, children }: ContentPageProps) => (
  <div className="landing">
    <header className="landing__header">
      <button
        type="button"
        className="landing__brand"
        onClick={onBack}
        style={{ background: "none", border: "none", cursor: "pointer" }}
      >
        <img className="landing__logo" src={PLATFORM.logoSrc} alt="" aria-hidden="true" />
        <span className="landing__brand-name">{PLATFORM.platform_name}</span>
      </button>
      <button
        type="button"
        className="btn"
        onClick={onBack}
        style={{ marginLeft: "auto" }}
      >
        ← Back to home
      </button>
    </header>

    <section className="content">
      <h1 className="content__title">{title}</h1>
      {children}
    </section>
  </div>
);

export default ContentPage;
